import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-not-connected',
  templateUrl: './signup-not-connected.component.html',
  styleUrls: ['./signup-not-connected.component.scss']
})
export class SignupNotConnectedComponent implements OnInit {

  constructor(
    private location: LocationStrategy
  ) {
    this.location.onPopState(() => {
      window.location.href = window.location.href;
    });
  }

  ngOnInit(): void {

  }

  launchCGU() {
    const win: Window | null = window.open(`https://www.infomaniak.com/gtl/rgpd.documents`, '_blank', 'noopener,noreferrer');
      if (win !== null) {
        win.opener = null;
        (win.location as any) = 'http://domain.com'; // fake domain on purpose
      }
  }

}
